<template>
    <div>
        <ns-loader
            ref="ns-loader"
            :to-load="toLoad"
            @dataFetched="onDataFetched"
        >
            <loading-template slot="loader"></loading-template>
            <el-tabs
                slot="content"
                class="gcmcn-tabs"
                style="margin-top: 30px;"
                v-model="activeName"
                :key="feedResource.uid"
            >
                <el-tab-pane label="Details" name="details">
                    <feed-resource-details-tab
                        :feed-resource="feedResource"
                        :universe="universe"
                        @on-update-feed-resource="editFeedResource"
                        @trigger-refresh="triggerRefresh"
                    ></feed-resource-details-tab>
                </el-tab-pane>
                <el-tab-pane label="Configurations" name="configurations">
                    <feed-resource-configurations-tab
                        :feed-resource="feedResource"
                        :feed-resources="feedResources"
                        :configurations="feedResourceConfigurations"
                        @trigger-refresh="triggerRefresh"
                        :universe="universe"
                    ></feed-resource-configurations-tab>
                </el-tab-pane>
            </el-tabs>
        </ns-loader>
    </div>
</template>

<script>
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loaderV2.vue';
import LoadingTemplate from '@/components/partials/ns-loader-template.vue';
import FeedResourceConfigurationsTab from './feed-resource-configurations.vue';
import FeedResourceDetailsTab from './feed-resource-details.vue';
export default {
    name: 'FeedResourceDetails',
    components:{
        NsLoader,
        LoadingTemplate,
        FeedResourceConfigurationsTab,
        FeedResourceDetailsTab
    },
    props:{
        feedResource:{
            type: Object,
            required: true,
        },
        feedResources:{
            type: Array,
            required: true,
        },
        feedResourceConfigurations:{
            type: Array,
            required: false,
            default: ()=>{return [];}
        },
    },
    data () {
        return {
            activeName: 'details',
            runningFeedResourceModificationRequest: null,
            universe: null,
        };
    },
    computed:{
        toLoad () {
            return [
                {
                    name: 'universe',
                    model: 'universes',
                    uid: this.feedResource.universe_uid,
                },
            ];
        },
    },
    methods:{
        onDataFetched (res){
            this.$set(this, 'universe', res.universe);
        },
        editFeedResource(){
            this.$emit('on-update-feed-resource', this.feedResource);
        },
        triggerRefresh (){
            this.$emit('trigger-refresh');
            this.$refs['ns-loader'].triggerRefresh();
        },
    }
};
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/page/FeedResources/feedResourceDetails/index.vue